const TOKEN_KEY = 'lms.access_token'

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setAccessToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch {
    // Private mode.
  }
}

function apiBase(): string {
  const configured = import.meta.env.VITE_API_URL
  if (configured) return configured.replace(/\/$/, '')
  return ''
}

export class ApiError extends Error {
  status: number
  code?: string

  constructor(message: string, status: number, code?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  const token = getAccessToken()
  if (token) headers.set('Authorization', `Bearer ${token}`)

  const response = await fetch(`${apiBase()}/api${path}`, { ...options, headers })

  if (response.status === 204) return undefined as T

  const payload = (await response.json().catch(() => null)) as
    | (T & { error?: string; code?: string })
    | null

  if (!response.ok) {
    throw new ApiError(
      payload && typeof payload === 'object' && 'error' in payload && payload.error
        ? String(payload.error)
        : response.statusText,
      response.status,
      payload && typeof payload === 'object' ? payload.code : String(response.status),
    )
  }

  return payload as T
}
